import { Component } from 'react';

export default class ProgressLogo extends Component {
  constructor(props) {
    super(props);
    this.state = { logoPhase: 0 };
    this.timeout = window.setTimeout(this.animateLogos.bind(this), 300);
  }

  animateLogos() {
    this.setState({ logoPhase: (this.state.logoPhase + 1) % 6 });
    this.timeout = window.setTimeout(this.animateLogos.bind(this), 300);
  }

  componentWillUnmount() {
    window.clearTimeout(this.timeout);
  }

  render() {
    return (
      <div className="progress-logo-backdrop">
        <div className="progress-logo-container">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 216 216">
            {this.state.logoPhase === 0 && (
              <g className="tmp-logo-bars tmp-logo-four">
                <polygon
                  className="tmp-logo-bar"
                  points="0 0 0 216 30.86 216 30.86 30.86 0 0"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="61.71 61.71 61.71 216 92.57 216 92.57 92.57 61.71 61.71"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="185.14 30.86 185.14 216 216 216 216 0 185.14 30.86"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="123.43 92.57 123.43 216 154.29 216 154.29 61.71 123.43 92.57"
                />
              </g>
            )}
            {(this.state.logoPhase === 1 || this.state.logoPhase === 5) && (
              <g className="tmp-logo-bars tmp-logo-eight">
                <polygon
                  className="tmp-logo-bar"
                  points="57.6 57.6 57.6 216 72 216 72 72 57.6 57.6"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="0 0 0 216 14.4 216 14.4 14.4 0 0"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="28.8 28.8 28.8 216 43.2 216 43.2 43.2 28.8 28.8"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="86.4 86.4 86.4 216 100.8 216 100.8 100.8 86.4 86.4"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="144 72 144 216 158.4 216 158.4 57.6 144 72"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="201.6 14.4 201.6 216 216 216 216 0 201.6 14.4"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="172.8 43.2 172.8 216 187.2 216 187.2 28.8 172.8 43.2"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="115.2 100.8 115.2 216 129.6 216 129.6 86.4 115.2 100.8"
                />
              </g>
            )}
            {(this.state.logoPhase === 2 || this.state.logoPhase === 4) && (
              <g className="tmp-logo-bars tmp-logo-twelve">
                <polygon
                  className="tmp-logo-bar"
                  points="93.91 93.91 93.91 216 103.3 216 103.3 103.3 93.91 93.91"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="56.35 56.35 56.35 216 65.74 216 65.74 65.74 56.35 56.35"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="75.13 75.13 75.13 216 84.52 216 84.52 84.52 75.13 75.13"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="0 0 0 216 9.39 216 9.39 9.39 0 0"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="18.78 18.78 18.78 216 28.17 216 28.17 28.17 18.78 18.78"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="37.56 37.56 37.56 216 46.96 216 46.96 46.96 37.56 37.56"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="150.26 65.74 150.26 216 159.65 216 159.65 56.35 150.26 65.74"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="112.7 103.3 112.7 216 122.09 216 122.09 93.91 112.7 103.3"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="187.83 28.17 187.83 216 197.22 216 197.22 18.78 187.83 28.17"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="206.61 9.39 206.61 216 216 216 216 0 206.61 9.39"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="169.04 46.96 169.04 216 178.44 216 178.44 37.56 169.04 46.96"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="131.48 84.52 131.48 216 140.87 216 140.87 75.13 131.48 84.52"
                />
              </g>
            )}
            {this.state.logoPhase === 3 && (
              <g className="tmp-logo-bars tmp-logo-eighteen">
                <polygon
                  className="tmp-logo-bar"
                  points="61.71 61.71 61.71 216 67.89 216 67.89 67.89 61.71 61.71"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="74.06 74.06 74.06 216 80.23 216 80.23 80.23 74.06 74.06"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="98.74 98.74 98.74 216 104.91 216 104.91 104.91 98.74 98.74"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="49.37 49.37 49.37 216 55.54 216 55.54 55.54 49.37 49.37"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="86.4 86.4 86.4 216 92.57 216 92.57 92.57 86.4 86.4"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="12.34 12.34 12.34 216 18.51 216 18.51 18.51 12.34 12.34"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="37.03 37.03 37.03 216 43.2 216 43.2 43.2 37.03 37.03"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="0 0 0 216 6.17 216 6.17 6.17 0 0"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="24.69 24.69 24.69 216 30.86 216 30.86 30.86 24.69 24.69"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="111.09 104.93 111.09 216 117.26 216 117.26 98.76 111.09 104.93"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="197.49 18.53 197.49 216 203.66 216 203.66 12.36 197.49 18.53"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="172.8 43.22 172.8 216 178.97 216 178.97 37.04 172.8 43.22"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="185.14 30.87 185.14 216 191.31 216 191.31 24.7 185.14 30.87"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="209.83 6.19 209.83 216 216 216 216 0.01 209.83 6.19"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="135.77 80.24 135.77 216 141.94 216 141.94 74.07 135.77 80.24"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="123.43 92.59 123.43 216 129.6 216 129.6 86.42 123.43 92.59"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="148.11 67.9 148.11 216 154.29 216 154.29 61.73 148.11 67.9"
                />
                <polygon
                  className="tmp-logo-bar"
                  points="160.46 55.56 160.46 216 166.63 216 166.63 49.39 160.46 55.56"
                />
              </g>
            )}
          </svg>
        </div>
      </div>
    );
  }
}
